import BaseComponent from '../base-component/base-component'
import Preloader from '../../components/common/preloader'

class Pagination extends BaseComponent {
  cache: object

  constructor() {
    super()

    this.cache = {}
  }

  updateTargetsFromHTML(html: Document): void {
    if (!this.dataset.containerId) {
      return
    }

    const newResults = html.getElementById(this.dataset.containerId)
    const results = document.getElementById(this.dataset.containerId)

    if (newResults && results) {
      const targets = newResults.querySelectorAll(`.${this.dataset.target}`)
      const fragment = document.createDocumentFragment()

      targets.forEach(target => {
        fragment.appendChild(target)
      })

      results.appendChild(fragment)
    }
  }

  updateResultsFromHTML(html: Document): void {
    if (!this.dataset.containerId) {
      return
    }

    const newResults = html.getElementById(this.dataset.containerId)
    const results = document.getElementById(this.dataset.containerId)

    if (newResults && results) {
      const resultsParentNode = results.parentNode

      resultsParentNode.replaceChild(newResults, results)

      newResults.scrollIntoView({ behavior: 'smooth' })
    }
  }

  updateFromHTML(html: Document): void {
    const newPagination = html.querySelector('pagination-component')

    if (newPagination) {
      const clonedNewPagination = newPagination.cloneNode(true)

      this.replaceChildren(...clonedNewPagination.childNodes)
    }
  }

  get loadingOverlay(): Preloader {
    const prealoader = document.getElementById(this.dataset.overlayId || '')

    return new Preloader(prealoader)
  }
}

export default Pagination
